import type { ActionFunctionArgs } from '~/types/route-args';
import { data as routerData } from 'react-router';
import { isUserLoggedIn } from '~/modules/user/hook/use-user';
import { sendMarketingPreferencesEmail } from '~/modules/settings/api/send-marketing-preferences-email.server';

export const SEND_MARKETING_PREFERENCES_EMAIL_API =
    '/remix-api/settings/marketing-preferences-email';

/**
 * API endpoint to email the HubSpot marketing preferences centre link to the
 * current user. The address is taken from the session rather than the request
 * body so the endpoint cannot be used to email arbitrary recipients.
 * @see {@link packages/web/app/modules/settings/hooks/use-marketing-preferences-email.ts}
 */
export const action = async ({ context }: ActionFunctionArgs) => {
    const { logger, user } = context;

    if (!isUserLoggedIn(user)) {
        return routerData(null, { status: 401 });
    }

    try {
        const recipient = await sendMarketingPreferencesEmail({
            context,
            email: user.Email,
        });

        if (!recipient) {
            return routerData(null, { status: 500 });
        }

        return { recipient };
    } catch (error) {
        logger.error(`Error in ${SEND_MARKETING_PREFERENCES_EMAIL_API}`, {
            error,
        });
        return routerData(null, { status: 500 });
    }
};
